import { tags as t } from "@lezer/highlight";
import { createTheme, CreateThemeOptions } from "@uiw/codemirror-themes";

import colors from "./foundations/colors";

const base = {
  overflow: "hidden",
  border: "1px solid #00000010",
  borderRadius: "10px",
  ".cm-lintRange-error": {
    backgroundImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="6" height="3">%3Cpath%20d%3D%22m0%202.5%20l2%20-1.5%20l1%200%20l2%201.5%20l1%200%22%20stroke%3D%22%23${colors.brick[500]}%22%20fill%3D%22none%22%20stroke-width%3D%22.7%22%2F%3E</svg>')`,
  },
};

const light: CreateThemeOptions = {
  theme: "light",
  ...base,
  settings: colors.yaml,
  styles: [
    { tag: [t.comment, t.quote], color: colors.yaml.comment },
    { tag: [t.keyword], color: colors.yaml.keyword, fontWeight: "bold" },
    { tag: [t.atom], color: colors.yaml.key },
    { tag: [t.string], color: colors.yaml.value, fontWeight: 700 },
    { tag: [t.meta], color: colors.yaml.symbol },
    { tag: [t.typeName], color: "#DABAFF" },
    { tag: [t.definition(t.variableName)], color: "#6BDFFF" },
    { tag: [t.name], color: "#6BAA9F" },
    { tag: [t.variableName], color: "#ACF2E4" },
    { tag: [t.regexp, t.link], color: colors.niagara[500] },
  ],
};

const dark: CreateThemeOptions = {
  theme: "dark",
  ...base,
  settings: colors._yaml,
  styles: [
    { tag: [t.comment, t.quote], color: colors._yaml["comment"] },
    { tag: [t.keyword], color: colors._yaml["keyword"] },
    { tag: [t.atom], color: colors._yaml["key"] },
    { tag: [t.string], color: colors._yaml["value"], fontWeight: 700 },
    { tag: [t.meta], color: colors._yaml["symbol"] },
    { tag: [t.typeName], color: "#DABAFF" },
    { tag: [t.definition(t.variableName)], color: "#6BDFFF" },
    { tag: [t.name], color: "#6BAA9F" },
    { tag: [t.variableName], color: "#ACF2E4" },
    { tag: [t.regexp, t.link], color: colors.niagara[500] },
  ],
};

export const codemirror = {
  light: createTheme(light),
  dark: createTheme(dark),
};

export default codemirror;
